"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Sidebar/SettingsIcon/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactredux = require('react-redux');

var _persistor = require('web/services/persistor');
var _myRelations = require('shared/selectors/myRelations');
var _user = require('shared/selectors/user');
var _app = require('shared/selectors/app');
var _hooks = require('web/services/hooks');
var _WhatsNew = require('web/components/WhatsNew');

var _Tooltip = require('web/components/Tooltip');
var _PendingUsersWarning = require('./PendingUsersWarning'); var _PendingUsersWarning2 = _interopRequireDefault(_PendingUsersWarning);
var _Icon = require('../Icon'); var _Icon2 = _interopRequireDefault(_Icon);







const WARNING_DELAY = 1600
const PENDING_USERS_WARNING_KEY = 'wasPendingUsersWarningSeen'
const tooltipOffsetHor = { left: -12 }
const tooltipOffsetVer = { bottom: 10 }

const SettingsIcon = ({
  as: Button = _Icon2.default,
  tooltipPlace,
  title,
  shortTitle,
  iconName,
  isActive,
  onClick,
}) => {
  const myUserKey = _hooks.useAppSelector.call(void 0, _user.selectCurrentUserKey)
  const pendingUsers = _hooks.useAppSelector.call(void 0, _myRelations.selectAllPendingUsers, _reactredux.shallowEqual)
  const isAppOutdated = _hooks.useAppSelector.call(void 0, _app.selectIsAppOutdated)
  // The tab bar points to the What's New row in Settings until it is opened;
  // the desktop sidebar has its pill instead.
  const hasNewsDot = _WhatsNew.useMyWhatsNew.call(void 0, ).status === 'unopened' && Button === _Icon2.default

  const [isWarningActive, setIsWarningActive] = _react.useState(false)
  const warningTimeout = _react.useRef(null)
  const showWarning = () => {
    setIsWarningActive(false)
    if (warningTimeout.current) clearTimeout(warningTimeout.current)
    warningTimeout.current =
      setTimeout(() => setIsWarningActive(true), WARNING_DELAY)
  }
  const dismissWarning = () => {
    _persistor.persistValue.call(void 0, myUserKey, PENDING_USERS_WARNING_KEY, true)
    setIsWarningActive(false)
  }

  const isPendingUsersWarningSeen =
    _persistor.getPersistedValue.call(void 0, myUserKey, PENDING_USERS_WARNING_KEY)

  const pendingUsersCount = pendingUsers.length
  _react.useEffect.call(void 0, 
    () => { if (!isPendingUsersWarningSeen && pendingUsersCount > 0) showWarning() },
    [isPendingUsersWarningSeen, pendingUsersCount],
  )

  return (
    _react2.default.createElement(_Tooltip.ControlledTooltip, {
      isOpen: isWarningActive,
      type: "light",
      place: tooltipPlace,
      onClose: dismissWarning,
      isAnimated: true,
      hasCloseButton: true,
      offset: tooltipPlace === 'right' ? tooltipOffsetHor : tooltipOffsetVer,
      content: isWarningActive ? _react2.default.createElement(_PendingUsersWarning2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 73}} ) : null,
      tooltipClassName: "tooltip--upgrade-warning", __self: this, __source: {fileName: _jsxFileName, lineNumber: 65}}

      , _react2.default.createElement(Button, {
        shouldHideTitleTooltip: isWarningActive,
        title: title,
        shortTitle: shortTitle,
        iconName: iconName,
        hasBadge: isAppOutdated,
        badgeCount: pendingUsersCount,
        hasNewsDot: hasNewsDot,
        onClick: onClick,
        isActive: isActive, __self: this, __source: {fileName: _jsxFileName, lineNumber: 76}}
      )
    )
  )
}

exports. default = _react.memo.call(void 0, SettingsIcon)
